var render = function (_h,_vm) {var _c=_vm._c;return _c('c-product-colors',_vm._b({class:['product-configurator-editor-color', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id,"colors":_vm.props.items,"large-preview":_vm.props.largePreview,"extended":""}},'c-product-colors',_vm.data.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }